<!-- 第一步  选择镜片用途 -->
<template>
  <div class="step-body">
    <div class="list">
      <!-- <div v-for="(item, index) in list" :key="item.id" class="item" :class="{ active: index == current }" @click="select(index)"></div> -->
      <div v-for="(item, index) in list" :key="item.vaule" class="item" :class="{ active: index == current }" @click="select(index)">
        <div class="left">
          <img :src="item.icon" alt="Preview" />
        </div>
        <div class="right">
          <template v-if="glassesType === 'eyeglasses'">
            <p class="text-title">{{ item.name }} {{ item.money == 0 ? '' : currencyIcon + '' + item.money }}</p>
          </template>
          <template v-else>
            <p class="text-title">{{ item.name }} {{ item.money == 0 ? 'Free' : currencyIcon + '' + item.money }}</p>
          </template>
          <p class="text-tips">{{ item.describe }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import flow from '@/components/Lproduct/mixin/getFlow'
export default {
  name: 'lensesUse',
  mixins: [flow],
  data() {
    return {
      current: null // 当前选中用途
    }
  },
  watch: {},
  created() {},

  activated() {
    if (this.$route.query.type === 'edit' && this.selectData.length) {
      // 找到对应数据下标
      const index = this.selectData.findIndex(item => {
        return item.type === 'lens_use'
      })
      if (index !== -1) {
        // 设置选中项目
        const currentIndex = this.list.findIndex(item => {
          return item.value === this.selectData[index].value
        })
        if (currentIndex !== -1) {
          this.current = currentIndex
        }
      }
    }
    // getFlowInfo
  },
  methods: {
    select(index) {
      this.current = index
      this.$emit('lensesUse', {
        data: this.list[index],
        type: 'lens_use'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.step-body {
  .list {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: auto;
    width: 990px;
    margin: 0 auto;
    overflow: auto;
    .item {
      height: 110px;
      width: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 4px;
      border: 1px solid #525861;
      border-radius: 5px;
      cursor: pointer;
    }
    .item:hover {
      transition: all 0.5s;
      border: 1px solid #3067f2;
      background: rgb(48, 103, 242, 0.18);
      box-shadow: 0px 0px 4px #3067f2;
    }
    .active {
      border: 1px solid #3067f2;
      background: rgb(48, 103, 242, 0.18);
    }
  }
  .left {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 140px;
    height: 80px;
    flex-shrink: 0;
    img {
      // height: 64px;
      width: 55%;
    }
  }
  .right {
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: #525861;
    p {
      margin-bottom: 0;
    }
    .text-title {
      font-size: 18px;
      font-weight: 600;
      color: #2b2e33;
      margin-bottom: 10px;
    }
  }
  .option {
    margin-top: 20px;
    width: 88px;
    border-bottom: 1px solid #2b2e33;
    cursor: pointer;
    img {
      width: 17px;
      height: 10px;
    }
  }
}
</style>
<style scoped lang="scss">
@media screen and (max-width: 960px) {
  .step-body {
    .list {
      width: 100%;
      .item {
        padding: 20px 0;
        height: 105px;
      }
    }
  }
}
@media screen and (max-width: 600px) {
  .step-body {
    .left {
      width: 96px;
      height: 77px;
      img {
        // height: 52px;
        width: 55%;
      }
    }
    .right {
      font-size: 13px;
      padding-right: 20px;
      .text-title {
        font-size: 13px;
        margin-bottom: 6px;
      }
    }
  }
}
</style>
